function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "85EE2416-3BE3-4915-88CF-9D7AD130A74F@1.00x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-64.000000, -1248.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-right",
  transform: "translate(64.000000, 1248.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "box",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "icon24/arrow-right",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7071068,4.29289322 C16.0976311,3.90236893 16.7307961,3.90236893 17.1213203,4.29289322 C17.4818043,4.65337718 17.5095338,5.22060824 17.204509,5.61289944 L17.1213203,5.70710678 L10.8292136,12 L17.1213203,18.2928932 C17.4818043,18.6533772 17.5095338,19.2206082 17.204509,19.6128994 L17.1213203,19.7071068 C16.7608364,20.0675907 16.1936053,20.0953203 15.8013141,19.7902954 L15.7071068,19.7071068 L8,12 L15.7071068,4.29289322 Z",
  id: "symbol",
  transform: "translate(12.707107, 12.000000) scale(-1, 1) translate(-12.707107, -12.000000) "
})))));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.3a1f0b60.svg";
export { ForwardRef as ReactComponent };